import {Component, effect, inject, signal} from '@angular/core';
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";

import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {isEqualToOrYoungerThanOffset} from "src/app/app.config";
import {Device, FixedSamplePoint} from "src/app/infrastructure/moovement-api/models/asset";
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {Router} from '@angular/router';
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {oneHour} from 'src/app/presentation/common/globals';
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';

@Component({
  selector: 'app-proximity-sample-points-button',
  imports: [
    BluetoothSvgComponent,
    LoadingPlaceholderComponent
  ],
  templateUrl: './proximity-sample-points-button.component.html',
  styleUrl: './proximity-sample-points-button.component.css'
})
export class ProximitySamplePointsButtonComponent {

  onlineProximitySamplePoints = signal<FixedSamplePoint[]>([]);
  offlineProximitySamplePoints = signal<FixedSamplePoint[]>([]);
  unassignedBluetoothProximitySensors = signal<Device[]>([]);
  loading = signal(true);

  Status = Status;

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private deviceStore = inject(DeviceStore);
  private fixedSamplePointsStore = inject(FixedSamplePointsStore);
  private router = inject(Router);

  constructor() {
    effect(() => {
      const unassignedBluetoothProximitySensors = this.deviceStore.unassignedBluetoothProximitySensors();
      this.unassignedBluetoothProximitySensors.set(unassignedBluetoothProximitySensors);
    });

    effect(() => {
      const loadingAggregatedState = this.aggregatedAssetStateStore.loading();
      const loadingProximitySamplePoints = this.fixedSamplePointsStore.loading();
      if (loadingAggregatedState || loadingProximitySamplePoints) return;

        const onlineProximitySamplePoints: FixedSamplePoint[] = [];
        const offlineProximitySamplePoints: FixedSamplePoint[] = [];
        this.fixedSamplePointsStore.proximitySamplePoints().forEach(proximitySamplePoint => {
          const aggregatedState = this.aggregatedAssetStateStore.entityMap()[proximitySamplePoint.id];
          const lastSeenByGatewayAt = aggregatedState?.lastSeenByGatewayAt;
          const isOnline = lastSeenByGatewayAt !== undefined && isEqualToOrYoungerThanOffset(lastSeenByGatewayAt, oneHour);
          (isOnline ? onlineProximitySamplePoints : offlineProximitySamplePoints).push(proximitySamplePoint);
        });

        this.onlineProximitySamplePoints.set(onlineProximitySamplePoints);
        this.offlineProximitySamplePoints.set(offlineProximitySamplePoints);
        this.loading.set(false);
    });
  }

  open(url: string): void {
    this.router.navigate([url]);
  }
}
